import React from 'react'
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { handleValidateCodevalue } from '../../Utility/constant';
import { useSelector } from 'react-redux';

const InfoIcon = ({text}) => {
    
    const internationalise = useSelector(state => state?.internationalise?.currentHashMapData)
    
  return (
         <span className='info-text mt-15 mb-20'>
              <InfoOutlinedIcon sx={{ fontSize: '20px' }} />
                {handleValidateCodevalue(internationalise, text)}
            </span>
  )
}

export default InfoIcon